import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLink, faBug } from '@fortawesome/free-solid-svg-icons'
import { faSteam, faDiscord } from '@fortawesome/free-brands-svg-icons'

const Container = styled.div`
  cursor: default;
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.8);
  animation: fadein 0.8s;

  @keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
`

const Content = styled.div`
  z-index: 101;
  background-color: ${props => props.theme.modalBg};
  color: ${props => props.theme.modalFg};
  margin: 80px auto;
  padding: 20px 25px;
  border: 1px solid #888;
  width: 80%;
  max-width: 700px;
`

const CloseButton = styled.span`
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  
  &:hover, &:focus {
    color: #fff;
    text-decoration: none;
    cursor: pointer;
  }
`

const Title = styled.h1`

`

const TextContent = styled.p`

`

const ExternalLink = styled.a`
  color: ${props => props.theme.modalFg};
  text-decoration: none;
  font-size: 1.2rem;
  display: block;
  margin-bottom: 10px;
  transition: 0.4s;
  
  svg {
    margin-right: 6px;
  }
  
  &:hover {
    margin-left: 5px;
    text-decoration: underline;
  }
`

const calculateTaskDate = (task, endDate) => {
    let y = task.year
    let q = task.quarter
    if(endDate) {
        for(let i = 1; i < task.quarterLength; i++) {
            q++;
            if(q > 4) {
                q = 1;
                y++;
            }
        }
    }
    return `${y} Q${q}`
}

const TaskInfo = ({task}) => (
    <TextContent>
        <b>Start:</b> {calculateTaskDate(task, false)}<br />
        <b>End:</b> {calculateTaskDate(task, true)}
    </TextContent>
)

const SteamLink = ({url}) => (
    <ExternalLink href={url} target='_blank' rel='noreferrer'><FontAwesomeIcon icon={faSteam} />Visit Steam page</ExternalLink>
)

const DiscordLink = ({url}) => (
    <ExternalLink href={url} target='_blank' rel='noreferrer'><FontAwesomeIcon icon={faDiscord} />Discord server</ExternalLink>
)

const WebsiteLink = ({url, text, icon}) => (
    <ExternalLink href={url} target='_blank' rel='noreferrer'><FontAwesomeIcon icon={icon} />{text}</ExternalLink>
)

const Modal = ({onClose, title, text, task, links}) => {

    return(
        <Container>
            <Content>
                <CloseButton onClick={onClose}>&times;</CloseButton>
                <Title>{title}</Title>
                <TextContent>{text}</TextContent>
                {task && <TaskInfo task={task}/>}
                {links && links.website && <WebsiteLink url={links.website} text="Official website" icon={faLink}/>}
                {links && links.steam && <SteamLink url={links.steam}/>}
                {links && links.changelog && <WebsiteLink url={links.changelog} text="Changelog" icon={faSteam}/>}
                {links && links.troubleshooting && <WebsiteLink url={links.troubleshooting} text="Troubleshooting" icon={faSteam}/>}
                {links && links.discord && <DiscordLink url={links.discord}/>}
                {links && links.bugtracker && <WebsiteLink url={links.bugtracker} text="Bugtracker" icon={faBug}/>}
            </Content>
        </Container>
    )
}

export default Modal
